// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5QO9B","right":"styles_right__25XSX"};